import Animation from './animation'
import * as decorations from '../decorations'
import * as d3 from 'd3-selection'
import { interpolate } from 'd3-interpolate'

/*
 * Animation when the first and second level breakdowns are swapped
 */
class SwapBreakdownAnimation extends Animation {

  constructor (options) {
    super(options)
    this.ripple = true
  }

  match (serie) {
    return this.chart.datum().swappingBreakdowns
  }

  animate (serie, entering, selection, merged, exiting) {
    let labelsConfig = this.labelsConfig
    // The new rects start in the previous locations
    // We have to use the previous scales, reversing ids
    entering.append('rect')
            .attr('y', d => this.previous.yScale(Math.max(0, d._range[1])))
            .attr('height', d => Math.abs(this.previous.yScale(d._range[0]) - this.previous.yScale(d._range[1])))
            .attr('width', d => this.serieScale.bandwidth())
            .attr('x', d => {
              return this.previous.scalers.x.plotScale(d.rangeId) +
                     this.previous.scalers.x.groupScale(this.plotId) +
                     this.serieScale(serie._columnIdx)
            })

    entering.call(decorations.default, this.strokeWidth)
            .call(decorations.position, this.strokeWidth, {}, labelsConfig)

    let scalers = this.scalers.x
      , serieScale = this.serieScale
      , plotId = this.plotId
      , strokeWidth = this.strokeWidth

    merged.duration(this.timing.duration)
          .delay(this.timing.delay)
          .tween('decorations', this.tweeners.decorations)
          .tween('all', this.tweeners.all)
          .tween('x', function (d) {
            let container = d3.select(this)
              , rect = container.select('rect')
              , final = scalers.groupScale(d.rangeId) + serieScale(serie._columnIdx) + scalers.plotScale(plotId)
              , interpolateX = interpolate(rect.attr('x'), final)

            return t => {
              let x = interpolateX(t)

              rect.attr('x', x)
              container.call(decorations.position, strokeWidth, {x}, labelsConfig)
            }
          })
          .end().then(() => {
            entering.selectAll('rect')
                    .attr('x', d => this.scalers.x.groupScale(d.rangeId) + this.serieScale(serie._columnIdx))
            entering.call(decorations.default, this.strokeWidth)
                    .call(decorations.position, this.strokeWidth, {}, labelsConfig)
          })
          .catch(() => {
            // Interrupted exception, ignore
          })

  }

}

export default SwapBreakdownAnimation
